import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ESigningEnvelopeDetailsComponent } from '../envelope-draft/e-signing-envelope-details/e-signing-envelope-details.component';
import { ESigningRecipientStatusDetailsComponent } from '../envelope-draft/e-signing-recipient-status-details/e-signing-recipient-status-details.component';
import { STATUSES } from '@models/statuses';
import {
	ClientSigningDetailsViewModel,
	SigningElementPackageViewModelComplete,
} from '@models/e-signing';
@Component({
	selector: 'app-envelope-view',
	imports: [
		ESigningEnvelopeDetailsComponent,
		ESigningRecipientStatusDetailsComponent,
	],
	templateUrl: './envelope-view.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: { class: 'h-full' },
})
export class EnvelopeViewComponent {
	public matterId_ = input<string>();
	public envelopeStatus_ = input<STATUSES>();
	public recipients_ = input<ClientSigningDetailsViewModel[]>();
	public documentNames_ = input<string[]>();
	public envelope_ = input<SigningElementPackageViewModelComplete>();
}
